import { Box, Tab, Tabs } from '@mui/material'
import React, { useState } from 'react'
import brgyList from '../../utils/geoData/barangay.json'
import cityList from '../../utils/geoData/city.json'
import provinceList from '../../utils/geoData/province.json'
import regionList from '../../utils/geoData/region.json'
import { ButtonList } from './ButtonList'

function TabPanel(props) {
  const { children, value, index } = props

  return (
    <>
      {value === index && (
        <Box sx={{ p: 1, maxHeight: 350, overflow: 'scroll' }}>{children}</Box>
      )}
    </>
  )
}

export const AddressSelect = ({
  region,
  province,
  city,
  brgy,
  onSelectRegion,
  onSelectProvince,
  onSelectCity,
  onSelectBrgy
}) => {
  const [value, setValue] = useState(0)

  const handleChange = (event, newValue) => {
    setValue(newValue)
  }

  const nextTab = () => {
    setValue(value !== 3 ? value + 1 : value)
  }

  const regionSelect = region => {
    onSelectRegion(region)
    nextTab()
  }

  const provinceSelect = province => {
    onSelectProvince(province)
    nextTab()
  }

  const citySelect = city => {
    onSelectCity(city)
    nextTab()
  }

  const brgySelect = city => {
    onSelectBrgy(city)
  }

  return (
    <Box sx={{ bgcolor: 'background.paper', width: '100%' }}>
      <Tabs
        value={value}
        onChange={handleChange}
        textColor='inherit'
        variant='fullWidth'
      >
        <Tab label='Region' />
        <Tab
          label='Province'
          disabled={region === undefined || region === null || region === ''}
        />
        <Tab
          label='City'
          disabled={
            province === undefined || province === null || province === ''
          }
        />
        <Tab
          label='Barangay'
          disabled={city === undefined || city === null || city === ''}
        />
      </Tabs>
      <Box>
        <TabPanel value={value} index={0}>
          <ButtonList
            list={regionList.map(item => ({
              label: item.region_name,
              code: item.region_code
            }))}
            onSelect={regionSelect}
            current={region}
          />
        </TabPanel>
        <TabPanel value={value} index={1}>
          {region !== undefined && (
            <ButtonList
              list={provinceList
                .filter(prov => prov.region_code === region.code)
                .map(item => ({
                  label: item.province_name,
                  code: item.province_code
                }))}
              onSelect={provinceSelect}
              current={province}
            />
          )}
        </TabPanel>
        <TabPanel value={value} index={2}>
          {province !== undefined && (
            <ButtonList
              list={cityList
                .filter(city => city.province_code === province.code)
                .map(item => ({
                  label: item.city_name,
                  code: item.city_code
                }))}
              onSelect={citySelect}
              current={city}
            />
          )}
        </TabPanel>
        <TabPanel value={value} index={3}>
          {city !== undefined && (
            <ButtonList
              list={brgyList
                .filter(brgy => brgy.city_code === city.code)
                .map(item => ({
                  label: item.brgy_name,
                  code: item.brgy_code
                }))}
              onSelect={brgySelect}
              current={brgy}
            />
          )}
        </TabPanel>
      </Box>
    </Box>
  )
}
